import { computed, ref } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { resolvePageId } from '@rebuild/utils/context';

export const useSurfAnnouncement = () => {
	const { announcement } = useModuleData();
	const { config, loadModuleConfig } = useModuleConfig();
	const { viewModule } = useModuleNavigation();

	// Tabs 数据
	const typeRange = computed(() => {
		const tabs = config.value?.tab || [];

		const PREFIX = 'classif_id_';
		const parseId = id => {
			// 特殊枚举：全部
			if (id === 'announcement_all') return '';

			// 正常枚举：classif_id_10101 → 10101
			if (id.startsWith(PREFIX)) {
				return id.slice(PREFIX.length);
			}

			// 兜底处理（防止未来出现未预料的结构）
			return id;
		};

		return tabs
			.filter(tab => tab.isPublish)
			.sort((a, b) => a.sort - b.sort)
			.map(tab => {
				const mainId = parseId(tab.id);

				// 处理子类 ID
				const subIds = (tab.subTabList || []).map(sub => parseId(sub.id)).filter(Boolean); // 去掉空字符串

				// 合并成 '10101,10102'
				const tabId = [mainId, ...subIds].filter(Boolean).join(',');

				return {
					...tab,
					tabId,
					label: tab.name
				};
			});
	});
	const getFullTypeRange = () => {
		const types = typeRange.value.map(item => item.tabId);

		// 全量查询
		// 区分「全部」是否包含子类型的情况
		const allValue = '';
		if (types.includes(allValue)) return allValue;

		return typeRange.value.map(item => item.tabId).join(',');
	};

	// 加载配置和初始化
	const initConfig = async () => {
		await loadModuleConfig('announcement');
	};

	const activeType = ref('');
	// 切换分类
	const handleTypeChange = tabId => {
		activeType.value = tabId;
	};

	// 数据
	const announcementData = computed(() => {
		const data = announcement.data?.data || [];
		return data;
	});
	// 加载数据
	const loadAnnouncementData = async (params = {}) => {
		await announcement.refresh({
			classificationIds: params.classificationIds || '',
			pageStart: params.pageStart,
			pageNum: params.pageNum,
			order: 'desc',
			title: params.title || '',
			pageId: resolvePageId()
		});
	};
	// 是否为空
	const isEmpty = computed(() => {
		return announcement.empty || !announcementData.value.length;
	});

	const formatForOverview = item => {
		return {
			date: item.publishDate || '',
			value: item.title || '',
			value2: item.parentClassification || ''
		};
	};

	// 预览详情
	const handlePreview = item => {
		viewModule('announcement', item);
	};

	return {
		announcement,
		typeRange,
		activeType,
		announcementData,
		getFullTypeRange,
		initConfig,
		loadAnnouncementData,
		formatForOverview,
		handlePreview,
		handleTypeChange,
		isEmpty
	};
};
